import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchBestSellingProductsAPI } from "./bestSellingAPI";

export const fetchBestSellingProductsData = createAsyncThunk(
    "bestSelling/fetchBestSellingProductsData",
    async () => {
        const data = await fetchBestSellingProductsAPI();
        return data
    }
)

const bestSellingSlice = createSlice({
    name: "bestSellingProducts",
    initialState: {
        bestSellingProducts: {},
        loading: false,
        error: null
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
        .addCase(fetchBestSellingProductsData.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchBestSellingProductsData.fulfilled, (state, action) => {
            state.loading = false;
            state.bestSellingProducts = action.payload.data || {};
        })
        .addCase(fetchBestSellingProductsData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
    }
})

export default bestSellingSlice.reducer;